import Micro from './Micro'

export default Micro
